import { useLayers } from 'hooks/queries/layers/useLayers'
import { useAuth } from 'hooks/UseAuth'
import { EditOnExistingLayerButton } from './EditOnExistingLayerButton'
import { EditOnNewLayerButton } from './EditOnNewLayerButton'
import { ButtonProps } from '../Button/Types'
import Styles from './EditOnLayerButton.module.scss'
import cx from 'classnames'
import { ReactComponent as EditIcon } from 'assets/icons/edit16.svg'
import { ReactComponent as SuggestionIcon } from 'assets/icons/suggest16.svg'

interface Props extends Pick<ButtonProps, 'variant' | 'isDisabled' | 'size' | 'className'> {
  articleKey: string
  children?: string
}

export const EditOnLayerButton = ({ articleKey, className, children, ...rest }: Props) => {
  const auth = useAuth()
  const { data } = useLayers({ articleKey })
  const mainLayer = data?.layers.find((layer) => layer.is_main)

  if (!auth) {
    return null
  }

  const myLayers = (data?.layers || []).filter((layer) => layer.owner.id === auth?.id && !layer.is_main)
  const myLayer = myLayers[0]

  const buttonText = mainLayer?.permissions?.can_edit ? 'Edit on Layer' : 'Suggest'
  const dataTestId = mainLayer?.permissions?.can_edit ? 'edit-on-layer-button' : 'suggest-button'
  const layerVariables = mainLayer?.permissions?.can_edit
    ? {}
    : { name: `${auth ? auth.first_name : 'Anonymous'}'s Suggestions` }
  const frontIcon = mainLayer?.permissions?.can_edit ? EditIcon : SuggestionIcon

  if (myLayer) {
    return (
      <EditOnExistingLayerButton
        layerId={myLayer.id}
        className={cx(className, Styles.button)}
        frontIcon={frontIcon}
        dataTestId={dataTestId}
        {...rest}
      >
        {children || buttonText}
      </EditOnExistingLayerButton>
    )
  }

  return (
    <EditOnNewLayerButton
      articleKey={articleKey}
      className={cx(className, Styles.button)}
      frontIcon={frontIcon}
      layerVariables={layerVariables}
      dataTestId={dataTestId}
      {...rest}
    >
      {children || buttonText}
    </EditOnNewLayerButton>
  )
}
